import { call, put, select, takeLatest, delay } from "redux-saga/effects";
import * as API from "../../../containers/APIurls";
import apiClient from "../../../utils/apiClient";
import * as bulkUploadSlice from "./bulkUploadSlice";
import axios from "axios";
import * as GlobalSlice from "app/ducks/GlobalSlice";
import { initializeCheckout, getSessionCartInfo } from "pages/Checkout/ducks/sagas";
import ProfileEligibilityDetails from "../../BulkUpload/ducks/ProfileEligibility.json";
import * as selectors from "./selectors";
import uploadFileForRouter from "../../BulkUpload/ducks/uploadFileForRouter.json";
import processAddressCheckForBulkBI from "../../BulkUpload/ducks/processAddressCheckForBulkBI.json";
import BulkAddressCount from "../../BulkUpload/ducks/BulkAddressCount.json";
import retrieveAccountsMock from "../../BulkUpload/ducks/retrieveAccountsMock.json";
import getBIPlansCband from "../../BulkUpload/ducks/getBIPlansCband.json";
import getBIPlansLTE from "../../BulkUpload/ducks/getBIPlansLTE.json";
import retrieveBIDevice5G from "../../BulkUpload/ducks/retrieveBIDevice5G.json";
import mbaSuppression from "../../BulkUpload/ducks/mbaSuppression.json";
import getBillingAddressMock from "../../BulkUpload/ducks/getBillingAddressMock.json";
import getSavedShipppingAddressMock from "../../BulkUpload/ducks/getSavedShipppingAddressMock.json";
import submitOrderMock from "../../BulkUpload/ducks/submitOrderMock.json";
import BulkInternetAmountResp from "../../BulkUpload/ducks/BulkInternetAmountResp.json";

// import { setAPIError, setError, setGridwallList, setPageLoading, setPdpDeviceDetails, setProductDetail } from "pages/Marketplace/ducks/MarketplaceSlice";
let ecpdId;
let zipCode;
const useMockglobal = false;
function* getProfileEligibilityDetails() {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));

		const globalData = yield select(selectors.globalData);
		let ecpdId = globalData?.widgetInputParams?.ecpdId?.value ??
		             window?.mbtGlobal?.ecpdId ?? ""

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}
		const payloadProfile = {
			disabledForId: "ENABLE_BULK_WITH_PLAN_CODES",
			ecpdId: ecpdId ?? "",
			enabledForId: "ENABLE_BULK_WITH_PLAN_CODES",
			paramName: "ENABLE_BULK_WITH_PLAN_CODES",
			paramType: "MBT",
			resetParamValue: "Y",
			ruleType: "MBT"
		}

		// const globalData = yield select(selectors.globalData);
		// let responseAcc="";
		// let respInitCheckout ="";
		// const sessionCartData =
		//   globalData?.sessionCartData?.apiResponse?.prospectFlowData;

		try {
			//let requestBody =params.payload;	
			const useMock = useMockglobal;
			const response = useMock ? ProfileEligibilityDetails : yield apiClient.post(
				API.GET_PROFILE_ELIGIBILITY,
				//"https://mbqa2.sdc.vzwcorp.com/mbt/secure/companysvc/mbt/companycore/getProfileEligibilityDetails",
				payloadProfile,
				config
			);


			//  const payloadAcc=  {
			// clientId: globalData?.widgetInputParams?.clientName?.value ?? "",
			// accountNumber: "",
			// ecpdId: globalData?.widgetInputParams?.ecpdId?.value ?? window?.mbtGlobal?.ecpdId,
			// loginUserId: window?.mbtGlobal?.userId ?? "",
			// rootEcpdId: window?.mbtGlobal?.rootEcpdProfileId ?? "",
			// channel: globalData?.widgetInputParams?.clientName?.value ?? "",
			// csr:  window?.mbtGlobal?.isCSR ?? "",
			// csrRole: window?.mbtGlobal?.csrRole ?? "",
			// csrId:window?.mbtGlobal?.csrId ?? "",
			// csrFirstName:window?.mbtGlobal?.csrFirstName ?? "",
			// csrLastName: window?.mbtGlobal?.csrLastName ??"",
			// csrEmail: window?.mbtGlobal?.csrEmail ?? "",
			// csrRoleEligibleForCommerceOrdering: window?.mbtGlobal?.csrRoleEligibleForCommerceOrdering ?? ""
			// }
			if (response?.data?.serviceStatus?.success) {
				yield put(bulkUploadSlice.setProfileEligibilityDetails(response?.data));
			}
			else {
				yield put(
					bulkUploadSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage

					})
				);
				if (
					response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}

			}
			// if((responseAcc?.status === 200 && !!responseAcc?.data && (responseAcc?.data?.status?.success || responseAcc?.data?.response?.businessInfo?.bussinessName)))
			// {
			// 	yield call(getSessionCartInfo);
			// }
			// if((responseAcc?.status === 200 && !!responseAcc?.data && (responseAcc?.data?.status?.success || responseAcc?.data?.response?.businessInfo?.bussinessName)))
			// {
			//   respInitCheckout	=yield call (initializeCheckout);
			// }
			// else
			// {
			// 	yield put(
			// 		WCMPSlice.setErrorInfo({				
			// 			errResponse:responseAcc,
			// 			status: "FAILED",
			// 			errorStatusCode: responseAcc?.data?.status?.statusCode,			
			// 			errorStatusMessage: responseAcc?.data?.status?.statusMessage			

			// 		})
			// 	);
			// 	yield put(WCMPSlice.setErrorResponse(true));
			// }
			// yield put(WCMPSlice.setAddtoCartResponse(respInitCheckout));	
		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}
}
function* uploadFileForOrder(params) {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));

		const config = {
			headers: {
				'Content-Type': 'multipart/form-data',
			}
		}
		const payloadData = params.payload;

		// const globalData = yield select(selectors.globalData);
		// let responseAcc="";
		// let respInitCheckout ="";
		// const sessionCartData =
		//   globalData?.sessionCartData?.apiResponse?.prospectFlowData;

		try {
			//let requestBody =params.payload;	
			const useMock = useMockglobal;
			const response = useMock ? uploadFileForRouter : yield apiClient.post(
				API.UPLOAD_FILE_FORORDER,
				//"https://mbqa2.sdc.vzwcorp.com/mbt/secure/companysvc/mbt/companycore/getProfileEligibilityDetails",
				payloadData,
				config
			);

			if (response?.data?.serviceStatus?.success) {
				yield put(bulkUploadSlice.setUploadFileStatus(response?.data));
			}
			else {
				yield put(
					WCMPSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage

					})
				);
				if (
					response?.data?.status?.statusCode === "411"
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}

			}
			// if((responseAcc?.status === 200 && !!responseAcc?.data && (responseAcc?.data?.status?.success || responseAcc?.data?.response?.businessInfo?.bussinessName)))
			// {
			// 	yield call(getSessionCartInfo);
			// }
			// if((responseAcc?.status === 200 && !!responseAcc?.data && (responseAcc?.data?.status?.success || responseAcc?.data?.response?.businessInfo?.bussinessName)))
			// {
			//   respInitCheckout	=yield call (initializeCheckout);
			// }
			// else
			// {
			// 	yield put(
			// 		WCMPSlice.setErrorInfo({				
			// 			errResponse:responseAcc,
			// 			status: "FAILED",
			// 			errorStatusCode: responseAcc?.data?.status?.statusCode,			
			// 			errorStatusMessage: responseAcc?.data?.status?.statusMessage			

			// 		})
			// 	);
			// 	yield put(WCMPSlice.setErrorResponse(true));
			// }
			// yield put(WCMPSlice.setAddtoCartResponse(respInitCheckout));	
		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}

}

function* processAddressCheckBulk(params) {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));

		const globalData = yield select(selectors.globalData);
		let ecpdId = globalData?.widgetInputParams?.ecpdId?.value ??
		            window?.mbtGlobal?.ecpdId ?? ""
		const uploadFileName = params?.payload?.uploadFileName ?? "";
		const uploadedFileName = params?.payload?.uploadedFileName ?? "";

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}
		const payload = {
			ecpdId: ecpdId ?? "",
			flowType: params?.payload?.flowType || "CHECK_AVAILABILITY",
			shoppingPath: "EPB5G",
			transactionType: params?.payload?.flowType || "CHECK_AVAILABILITY",
			uploadFileName: uploadFileName,
			uploadedFileName: uploadedFileName,
			userId: window?.mbtGlobal?.userId ?? ""
		}

		try {
			//let requestBody =params.payload;	
			const useMock = useMockglobal;
			const response = useMock ? processAddressCheckForBulkBI : yield apiClient.post(
				API.PROCESS_ADDRESS_CHECK_BULK,
				//"https://mbqa2.sdc.vzwcorp.com/mbt/secure/companysvc/mbt/companycore/getProfileEligibilityDetails",
				payload,
				config
			);

			if (response?.data?.serviceStatus?.success) {
				yield put(bulkUploadSlice.setAddressCheckStatus(response?.data));
				if (response?.data?.fileId) {
					yield put(bulkUploadSlice.setFileId(response?.data?.fileId));
					yield call(getBulkAddressCount, response?.data?.fileId, 0);
				}
			}
			else {
				yield put(
					bulkUploadSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage

					})
				);
				if (
					response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}

			}

		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}
}

function* getBulkAddressCount(fileId, retrycount = 0) {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));
		const maxRetries = 5;
		const delayTime = 5000;

		const globalData = yield select(selectors.globalData);
		let ecpdId = globalData?.widgetInputParams?.ecpdId?.value ?? 
		              window?.mbtGlobal?.ecpdId ??""

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}
		const payload = {
			csrRole: ""
		}

		try {
			//let requestBody =params.payload;	
			const useMock = useMockglobal;
			const response = useMock ? BulkAddressCount : yield apiClient.post(
				API.GET_BULK_ADDRESS_COUNT + fileId,
				//"https://mbqa2.sdc.vzwcorp.com/mbt/secure/companysvc/mbt/companycore/getProfileEligibilityDetails",
				payload,
				config
			);

			if ((response?.data?.serviceStatus?.success &&
				response?.data?.poolingNeeded === false)
			) {
				yield put(bulkUploadSlice.setAddressCountResponse(response?.data));
				yield call(retrieveAccounts);
				// return response;	
			}
			else if (
				response?.data?.poolingNeeded === true && retrycount < maxRetries) {
				yield delay(delayTime);
				//const result =
				yield call(getBulkAddressCount, fileId, retrycount + 1);
				//return result;
			}
			else {
				yield put(
					bulkUploadSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage

					})
				);
				if (
					response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}

			}

		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}
}
function* retrieveAccounts() {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));

		const globalData = yield select(selectors.globalData);
		let ecpdId = globalData?.widgetInputParams?.ecpdId?.value ??
		             window?.mbtGlobal?.ecpdId ?? ""

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}
		const payload = {
			"clientId": "MBT",
			"ecpdId": ecpdId,
			"rootEcpdId": window?.mbtGlobal?.rootEcpdProfileId ?? "",
			"shoppingPath": "EPB5G",
			"transactionId": "MB3000011126084",
			"userId": window?.mbtGlobal?.userId ?? "",
			"searchValue": "",
			"biBulkFlow": true
		}

		try {
			//let requestBody =params.payload;	
			const useMock = useMockglobal;
			const response = useMock ? retrieveAccountsMock : yield apiClient.post(
				API.RETRIEVE_ACCOUNTS,
				//"https://mbqa2.sdc.vzwcorp.com/mbt/secure/companysvc/mbt/companycore/getProfileEligibilityDetails",
				payload,
				config
			);

			if (response?.data?.serviceStatus?.success) {
				yield call(getBIPlanBundlesBulk, "5G");
				yield put(bulkUploadSlice.setAcccount(response?.data));
				//by default call 5G internetoptions					 		
			}
			else {
				yield put(
					bulkUploadSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage

					})
				);
				if (
					response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}

			}

		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}
}
function* getBIPlanBundlesBulk(params) {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));
		yield put(bulkUploadSlice?.setBulkSelectedPlan(params));
		const globalData = yield select(selectors.globalData);
		let ecpdId = globalData?.widgetInputParams?.ecpdId?.value ??
		             window?.mbtGlobal?.ecpdId ?? ""

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}
		const plansPayload = {
			"ecpdId": ecpdId,
			"userId": window?.mbtGlobal?.userId ?? "",
			"clientId": "MBT",
			"pageInfo": {
				"offset": 0,
				"pageInfo": 5
			},
			"fetchLtePlans": params?.payload === "4G" || params === "4G" ? true : false,
			"fetchCbandPlans": params?.payload === "5G" || params === "5G" ? true : false,
			"bulkFlow": true
		}

		try {
			//let requestBody =params.payload;	
			const useMock = useMockglobal;
			const response = useMock ? params?.payload === "4G" || params === "4G" ? getBIPlansLTE : getBIPlansCband : yield apiClient.post(
				API.GET_BIPLAN_BUNDLES_BULK,
				//"https://mbqa2.sdc.vzwcorp.com/mbt/secure/companysvc/mbt/companycore/getProfileEligibilityDetails",
				plansPayload,
				config
			);

			if (response?.data?.serviceStatus?.success) {
				yield* ecpdAndMbaSuppression();
				yield put(bulkUploadSlice.setPlanDetails(response?.data));
			}
			else {
				yield put(
					bulkUploadSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage

					})
				);
				if (
					response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}

			}

		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}
}

function* retrieveBIService(params) {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));

		const globalData = yield select(selectors.globalData);
		let ecpdId = globalData?.widgetInputParams?.ecpdId?.value ??
		             window?.mbtGlobal?.ecpdId ?? ""
		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}
		const plansPayload = {
			"ecpdId": ecpdId,
			"userId": window?.mbtGlobal?.userId ?? "",
			"bulkOrder": true,
			"planBillingCode": params?.payload,
			"customerTypeVision": "",
			"shoppingPath": "EPB5G",
			"locationCode": ""
		}

		try {
			//let requestBody =params.payload;	
			const useMock = useMockglobal;
			const response = useMock ? retrieveBIDevice5G : yield apiClient.post(
				API.RETRIEVE_BI_DEVICE,
				//"https://mbqa2.sdc.vzwcorp.com/mbt/secure/companysvc/mbt/companycore/getProfileEligibilityDetails",
				plansPayload,
				config
			);

			if (response?.data?.status?.success) {
				yield put(bulkUploadSlice.setBIDeviceDetails(response?.data));
			}
			else {
				yield put(
					bulkUploadSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage

					})
				);
				if (
					response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}

			}

		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}
}

function* ecpdAndMbaSuppression() {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));

		const globalData = yield select(selectors.globalData);
		let ecpdId = globalData?.widgetInputParams?.ecpdId?.value ??
		             window?.mbtGlobal?.ecpdId ?? ""

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}
		const ecpdSuppressionPayload = {
			"ecpdId": ecpdId,
			"userId": window?.mbtGlobal?.userId ?? "",
		}

		try {
			//let requestBody =params.payload;	
			const useMock = useMockglobal;
			const response = useMock ? mbaSuppression : yield apiClient.post(
				API.ECPD_MBA_SUPPRESSION,
				ecpdSuppressionPayload,
				config
			);

			if (response?.data?.serviceStatus?.success) {
				yield put(bulkUploadSlice.setEcpdMbaSuppression(response?.data));
			}
			else {
				yield put(
					bulkUploadSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage

					})
				);
				if (
					response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}

			}

		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}
}

function* getBillingAddress(params) {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));

		const globalData = yield select(selectors.globalData);
		let ecpdId = globalData?.widgetInputParams?.ecpdId?.value ??
		             window?.mbtGlobal?.ecpdId ?? ""

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}
		const billingAddressPayload =
		{
			"ecpdId": ecpdId,
			"userId": window?.mbtGlobal?.userId ?? "",
			"shoppingPath": "EPB5G",
			"accountNumber": params?.payload,
			"clientId": "MBT",
			"transactionId": "MB3000011128060"
		}

		try {
			//let requestBody =params.payload;	
			const useMock = useMockglobal;
			const response = useMock ? getBillingAddressMock : yield apiClient.post(
				API.GET_BILLING_ADDRESS,
				billingAddressPayload,
				config
			);

			if (response?.data?.serviceStatus?.success) {
				yield* getSavedShippingAddress();
				yield put(bulkUploadSlice.setBillingAddress(response?.data));
			}
			else {
				yield put(
					bulkUploadSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage

					})
				);
				if (
					response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}

			}

		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}
}
function* getSavedShippingAddress() {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));

		const globalData = yield select(selectors.globalData);
		let ecpdId = globalData?.widgetInputParams?.ecpdId?.value ??
		             window?.mbtGlobal?.ecpdId ?? ""

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}
		const shippingAddressPayload = {
			"ecpdId": ecpdId,
			"userId": window?.mbtGlobal?.userId ?? "",
		}

		try {
			//let requestBody =params.payload;	
			const useMock = useMockglobal;
			const response = useMock ? getSavedShipppingAddressMock : yield apiClient.post(
				API.GET_SHIPPING_ADDRESS,
				shippingAddressPayload,
				config
			);

			if (response?.data?.serviceStatus?.success) {
				yield put(bulkUploadSlice.setShippingAddress(response?.data));
			}
			else {
				yield put(
					bulkUploadSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage

					})
				);
				if (
					response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}

			}

		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}
}

function* getBulkInternetAmount() {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));

		const globalData = yield select(selectors.globalData);
		const bulkuploadData = yield select(selectors.bulkuploadData);
		let ecpdId = globalData?.widgetInputParams?.ecpdId?.value ??
		            window?.mbtGlobal?.ecpdId ?? ""

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}
		const getBulkIntrenetAmountPayload5G = {
			"dppSelected": true,
			"accountNumber": bulkuploadData?.selectedAccount,
			"ecpdId": ecpdId,
			"userId": window?.mbtGlobal?.userId ?? "",
			"rootEcpdId": window?.mbtGlobal?.rootEcpdProfileId ?? "",
			"groupOrderNum": window?.mbtGlobal?.gon ?? "",
			"uploadedUserDetails": null,
			"smOrder": "N",
			"portInInfo": null,
			"flowType": "CHECK_AVAILABILITY",
			"fileId": bulkuploadData?.FileId,
			"cbandPlan": {
				"planPriceCode": bulkuploadData?.selectedBulkPlanId,
			},
			"cbandSelected": true,
			"sharedCartBypass": true,
			"sharedCartByPass": true
		};

		const getBulkIntrenetAmountPayload4G = {
			"dppSelected": true,
			"accountNumber": bulkuploadData?.selectedAccount,
			"ecpdId": ecpdId,
			"userId": window?.mbtGlobal?.userId ?? "",
			"rootEcpdId": window?.mbtGlobal?.rootEcpdProfileId ?? "",
			"groupOrderNum": window?.mbtGlobal?.gon ?? "",
			"uploadedUserDetails": null,
			"smOrder": "N",
			"portInInfo": null,
			"flowType": "CHECK_AVAILABILITY",
			"fileId": bulkuploadData?.FileId,
			"ltePlan": {
				"planPriceCode": bulkuploadData?.selectedBulkPlanId,
			},
			"lteSelected": true,
			"sharedCartBypass": true,
			"sharedCartByPass": true
		}
		try {
			//let requestBody =params.payload;	
			const useMock = useMockglobal;
			const response = useMock ? BulkInternetAmountResp : yield apiClient.post(
				API.GET_BULK_INT_AMOUNT,
				bulkuploadData?.bulkSelectedPlan === "5G" ? getBulkIntrenetAmountPayload5G : getBulkIntrenetAmountPayload4G || getBulkIntrenetAmountPayload5G,
				config
			);
			//no status	
			if (response?.data?.totalDueMonthly) {
				yield put(bulkUploadSlice.setBulkInternetAmtResp(response?.data));
			}
			else {
				yield put(
					bulkUploadSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage

					})
				);
				if (
					response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}

			}

		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}
}
function* SubmitOrder() {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));

		const globalData = yield select(selectors.globalData);
		const bulkUploadData = yield select(selectors.bulkuploadData);
		let ecpdId = globalData?.widgetInputParams?.ecpdId?.value ??
		             window?.mbtGlobal?.ecpdId ?? ""

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}

		const completeOrderPayload5G = {
			"accountNumber": bulkUploadData?.selectedAccount,
			"ecpdId": ecpdId,
			"userId": window?.mbtGlobal?.userId,
			"rootEcpdId": window?.mbtGlobal?.rootEcpdProfileId ?? "",
			"groupOrderNum": window?.mbtGlobal?.gon ?? "",
			"uploadedUserDetails": null,
			"smOrder": "N",
			"portInInfo": null,
			"billingAddressForShipping": true,
			"serviceAddressForShipping": false,
			"flowType": "CHECK_AVAILABILITY",
			"fileId": bulkUploadData?.FileId,
			"cbandPlan": {
				"planPriceCode": bulkUploadData?.selectedBulkPlanId
			},
			"cbandSelected": true,
			"cbandDevice": {
				"deviceSku": bulkUploadData?.selectedDevice,
				"contractTerm": bulkUploadData?.bulkContractTerm
			},
			"shipping": {
				"shippingCode": "SHP002",
				"shippingPrice": "0.0",
				"shippingDescription": "2 DAY SHIP BY 8PM",
				"address": null
			},
			"paymentInfo": {
				"userEmail": bulkUploadData?.BulkUploadEmail,
				"paymentType": "BTA"
			},
			"managerApprovalEnabled": false,
			"sharedCartBypass": true,
			"sharedCartByPass": true
		};
		const completeOrderPayload4G = {
			"accountNumber": bulkUploadData?.selectedAccount,
			"ecpdId": ecpdId,
			"userId": window?.mbtGlobal?.userId,
			"rootEcpdId": window?.mbtGlobal?.rootEcpdProfileId ?? "",
			"groupOrderNum": window?.mbtGlobal?.gon ?? "",
			"uploadedUserDetails": null,
			"smOrder": "N",
			"portInInfo": null,
			"billingAddressForShipping": true,
			"serviceAddressForShipping": false,
			"flowType": "CHECK_AVAILABILITY",
			"fileId": bulkUploadData?.FileId,
			"ltePlan": {
				"planPriceCode": bulkUploadData?.selectedBulkPlanId
			},
			"lteSelected": true,
			"lteDevice": {
				"deviceSku": bulkUploadData?.selectedDevice,
				"contractTerm": bulkUploadData?.bulkContractTerm
			},
			"shipping": {
				"shippingCode": "SHP002",
				"shippingPrice": "0.0",
				"shippingDescription": "2 DAY SHIP BY 8PM",
				"address": null
			},
			"paymentInfo": {
				"userEmail": bulkUploadData?.BulkUploadEmail,
				"paymentType": "BTA"
			},
			"managerApprovalEnabled": false,
			"sharedCartBypass": true,
			"sharedCartByPass": true
		};

		try {
			//let requestBody =params.payload;	
			const useMock = useMockglobal;
			const response = useMock ? submitOrderMock : yield apiClient.post(
				API.SUBMIT_BULK_INTERNET,
				bulkUploadData?.bulkSelectedPlan === "5G" ? completeOrderPayload5G : completeOrderPayload4G || completeOrderPayload5G,
				config
			);

			if (response?.data?.status?.success) {
				yield put(bulkUploadSlice.setCompleteOrderResp(response?.data));
			}
			else {
				yield put(
					bulkUploadSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage

					})
				);
				if (
					response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}

			}

		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}
}

function* retrieveBulkFileStatus(params) {
	try {
		const globalData = yield select(selectors.globalData);
		const widgetInputParams = globalData?.widgetInputParams;
		let ecpdId = widgetInputParams?.ecpdid?.value ?? window?.mbtGlobal?.ecpdId
		let userId = widgetInputParams?.mbloginid?.value ? widgetInputParams?.mbloginid?.value : window?.mbtGlobal?.userId;
		const payload = {
			"ecpdId": ecpdId,
			"flowType": params.payload || "",
			"sharedCartBypass": true,
			"sharedCartByPass": true,
			"userId": userId
		}

		const config = {
			headers: {
				'Content-Type': 'application/json',
			}
		}

		try {
			const useMock = useMockglobal;
			const response = useMock ? processAddressCheckForBulkBI : yield apiClient.post(
				API.RETRIEVE_BULK_FILE_STATUS,
				payload,
				config
			);

			if (!response?.data?.serviceStatus?.success) {
				yield put(
					bulkUploadSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage
					})
				);
				if (
					response?.data?.status?.statusCode === "411" || response?.data?.status?.statusMessage === "WCP_QUALITY_UNAVAILABLE" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_ACCESSORY_DETAILS" ||
					response?.data?.status?.statusMessage === "WCP_QUALITY_INVALID_SIM_DETAILS "
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}
			}

		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}
}

function* uploadFileForActivateRouters(params) {
	try {
		yield put(bulkUploadSlice.setAPIError(false));
		yield put(bulkUploadSlice.setPageLoading(true));

		const config = {
			headers: {
				'Content-Type': 'multipart/form-data',
			}
		}
		const payloadData = params.payload;

		try {
			const useMock = useMockglobal;
			const response = useMock ? uploadFileForRouter : yield apiClient.post(
				API.UPLOAD_FILE_FOR_ORDER_ROUTER,
				payloadData,
				config
			);

			if (response?.data?.serviceStatus?.success) {
				yield put(bulkUploadSlice.setUploadFileStatus(response?.data));
			}
			else {
				yield put(
					WCMPSlice.setErrorInfo({
						errResponse: response,
						status: "FAILED",
						errorStatusCode: response?.data?.status?.statusCode,
						errorStatusMessage: response?.data?.status?.statusMessage
					})
				);
				if (
					response?.data?.status?.statusCode === "411"
				) {
					yield put(WCMPSlice.setErrorResponse(true));
				}
			}
		} catch (err) {
			yield put(bulkUploadSlice.setAPIError(true));
		} finally {
			yield put(bulkUploadSlice.setPageLoading(false));
		}

	} catch (e) {
		//yield put(WCMPSlice.setIOTSimdetails(false))
	} finally {
		yield put(bulkUploadSlice.setPageLoading(false));
	}

}

export default function* actionWatcher() {
	yield takeLatest(bulkUploadSlice.getProfileEligibilityDetails.type, getProfileEligibilityDetails)
	yield takeLatest(bulkUploadSlice.uploadFileForOrder.type, uploadFileForOrder)
	yield takeLatest(bulkUploadSlice.processAddressCheckBulk.type, processAddressCheckBulk)
	yield takeLatest(bulkUploadSlice.getBulkAddressCount.type, getBulkAddressCount)
	yield takeLatest(bulkUploadSlice.retrieveAccounts.type, retrieveAccounts)
	yield takeLatest(bulkUploadSlice.getBIPlanBundlesBulk.type, getBIPlanBundlesBulk)
	yield takeLatest(bulkUploadSlice.retrieveBIService.type, retrieveBIService)
	yield takeLatest(bulkUploadSlice.ecpdAndMbaSuppression.type, ecpdAndMbaSuppression)
	yield takeLatest(bulkUploadSlice.getBillingAddress.type, getBillingAddress)
	yield takeLatest(bulkUploadSlice.getSavedShippingAddress.type, getSavedShippingAddress)
	yield takeLatest(bulkUploadSlice.getBulkInternetAmount.type, getBulkInternetAmount)
	yield takeLatest(bulkUploadSlice.SubmitOrder.type, SubmitOrder)
	yield takeLatest(bulkUploadSlice.retrieveBulkFileStatus.type, retrieveBulkFileStatus)
	yield takeLatest(bulkUploadSlice.uploadFileForActivateRouters.type, uploadFileForActivateRouters)
}